import { SpeakToTextDto } from 'types';
import { MESSAGE_DATE_HEIGHT, MESSAGE_SPACING, MESSAGE_SPACING_LARGE } from 'utils/constants';
import { MESSAGE_TYPE } from 'utils/enums';
import { calculateHeightSpeakToText } from './calculateHeightSpeakToText';
import { getPropsSpeakToTextItem } from './getPropsSpeakToTextItem';

export const calculateHeightSpeakToTextItem = async (
  message: SpeakToTextDto,
  nextMess?: SpeakToTextDto | null,
  prevMess?: SpeakToTextDto | null,
  maxWidth = 300,
  isShowName: boolean = true
) => {
  let heightMessage = 0;

  const { isFirstOfSender, isOnSameDate } = getPropsSpeakToTextItem(message, nextMess, prevMess);

  switch (message.type) {
    case MESSAGE_TYPE.TEXT:
      if (message.content) {
        heightMessage = calculateHeightSpeakToText(message, isFirstOfSender, maxWidth, isShowName);
      } else heightMessage = 0;

      break;
  }

  /** Chiều cao của ngày gửi tin nhắn khác ngày nhau */
  heightMessage += !!heightMessage && !isOnSameDate ? MESSAGE_DATE_HEIGHT : 0;

  /** Khoảng cách giữa các tin nhắn của cùng người gửi hay khác người gửi */
  heightMessage += !!heightMessage
    ? message.senderId !== nextMess?.senderId
      ? MESSAGE_SPACING_LARGE
      : MESSAGE_SPACING
    : 0;
  return heightMessage;
};
